import { render, staticRenderFns } from "./HandleIdentity.vue?vue&type=template&id=8ea44a9a&scoped=true&"
import script from "./HandleIdentity.vue?vue&type=script&lang=js&"
export * from "./HandleIdentity.vue?vue&type=script&lang=js&"
import style0 from "./HandleIdentity.vue?vue&type=style&index=0&id=8ea44a9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea44a9a",
  null
  
)

export default component.exports